import axios from "axios";
import store from "@/store";
import router from "@/router";

const _baseUrl = process.env.VUE_APP_ROOT_API;
const service = axios.create({
    baseURL:_baseUrl,
    timeout:60000,
    withCredentials:false
});

service.interceptors.request.use(function(config){
    config.headers['Accept']='application/json';
    config.headers['Content-Type'] = 'application/json';
    if(store.getters["isAuthenticated"]){
        let token = store.getters["StateUser"].token;
        config.headers['Authorization'] = 'Bearer '+token;
    }
    return config;
}, undefined);

service.interceptors.response.use(undefined, async function(error) {
    if (error && error.response) {
       const originalRequest = error.config;
       if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry=true;
        let result = await GetRefreshToken();
        if(result.status){
            originalRequest.headers['Authorization'] = 'Bearer ' + result.newToken;
            return service(originalRequest);
        }else{
            store.dispatch("LogOut", false);
            return router.push("/login");
        }
       }
       if (error.response.status===400){
            return Promise.reject(error.response.data);
       }else{
            console.log('Error.')
       }
   }
   return Promise.reject(error);
});

async function GetRefreshToken(){
    let result = {'status':false,'newToken':null};
    try {
        let token = await store.dispatch("RefreshToken");
        result.newToken = token;
        result.status = true;
    } catch {
        result.status = false;
    }
    return result;
}

export {service};
